// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2yn-A","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1xKQ3"};